var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _line, _line2, _rect7, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 30,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    width: 7,
    height: 30,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 1,
    width: 16,
    height: 28,
    fill: "#33A000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 5,
    height: 23,
    fill: "#267800"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 5,
    height: 23,
    fill: "#267800"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 12,
    height: 13,
    fill: "#267800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L19.9983 12.5",
    stroke: "#267800"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 11.5,
    x2: 19,
    y2: 11.5,
    stroke: "#267800"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10.5,
    x2: 18,
    y2: 10.5,
    stroke: "#267800"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 2,
    height: 10,
    fill: "#267800"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 3.5,
    x2: 7,
    y2: 3.5,
    stroke: "#267800"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 1.5,
    x2: 7,
    y2: 1.5,
    stroke: "#267800"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.5,
    x2: 7,
    y2: 2.5,
    stroke: "#267800"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 4.5,
    x2: 7,
    y2: 4.5,
    stroke: "#267800"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 3.5,
    x2: 26,
    y2: 3.5,
    stroke: "#267800"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1.5,
    x2: 24,
    y2: 1.5,
    stroke: "#267800"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 2.5,
    x2: 25,
    y2: 2.5,
    stroke: "#267800"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 4.5,
    x2: 27,
    y2: 4.5,
    stroke: "#267800"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19.5,
    x2: 13,
    y2: 19.5,
    stroke: "#FC9700"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 19.5,
    x2: 18,
    y2: 19.5,
    stroke: "#FC9700"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 18.5,
    x2: 18,
    y2: 18.5,
    stroke: "#FC9700"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17.5,
    x2: 17,
    y2: 17.5,
    stroke: "#FC9700"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16.5,
    x2: 16,
    y2: 16.5,
    stroke: "#FC9700"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 17.5,
    x2: 15,
    y2: 17.5,
    stroke: "#FC9700"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18.5,
    x2: 14,
    y2: 18.5,
    stroke: "#FC9700"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 20.5,
    x2: 18,
    y2: 20.5,
    stroke: "#FC9700"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 21.5,
    x2: 17,
    y2: 21.5,
    stroke: "#FC9700"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 21.5,
    x2: 16,
    y2: 21.5,
    stroke: "#FC9700"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21.5,
    x2: 15,
    y2: 21.5,
    stroke: "#FC9700"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 20.5,
    x2: 14,
    y2: 20.5,
    stroke: "#FC9700"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18.5,
    x2: 17,
    y2: 18.5,
    stroke: "#FFC700"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20.5,
    x2: 17,
    y2: 20.5,
    stroke: "#FFC700"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 19.5,
    x2: 17,
    y2: 19.5,
    stroke: "#FFC700"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 17,
    x2: 15.5,
    y2: 18,
    stroke: "#FFC700"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17.5,
    x2: 14,
    y2: 17.5,
    stroke: "#FF4D00"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 19,
    x2: 12.5,
    y2: 17,
    stroke: "#FF4D00"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 15.5,
    x2: 16,
    y2: 15.5,
    stroke: "#FF4D00"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 16.5,
    x2: 15,
    y2: 16.5,
    stroke: "#FF4D00"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 14,
    x2: 15.5,
    y2: 15,
    stroke: "#FF4D00"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 15,
    x2: 16.5,
    y2: 17,
    stroke: "#FF4D00"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 16,
    x2: 17.5,
    y2: 18,
    stroke: "#FF4D00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0a08fa78a23806996ec49d3feaa52ebb.svg";
export { ForwardRef as ReactComponent };